import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from 'src/cpwm/App'

if (self != parent) document.documentElement.classList.add('embedded')

window.Application = {
  start (data) {
    createRoot(document.getElementById('ApplicationRoot'))
    .render(<StrictMode><App {...data} /></StrictMode>)
  }
}
